import { useQuery } from "@tanstack/react-query";
import { getCustomerDetail } from "../api/customer";
import { DeleteMobility } from "../types/types";

const useGetCustomerDetail = (
  { seq }: DeleteMobility,
  {
    fetch,
  }: {
    fetch: boolean;
  }
) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ["Customer", `seq-${seq}`, `fetch-${fetch}`],
    queryFn: () => getCustomerDetail({ seq }),

    retry: false,
    enabled: fetch,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, isSuccess };
};

export default useGetCustomerDetail;
